export const ChevronDoubleLeft = ({
  size = 24,
  color = '#4FC0CF',
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6477 18.8486C12.1164 18.3799 12.1164 17.6202 11.6477 17.1515L6.49631 12L11.6477 6.84858C12.1164 6.37995 12.1164 5.62015 11.6477 5.15152C11.1791 4.68289 10.4193 4.68289 9.95068 5.15152L3.95068 11.1515C3.48205 11.6202 3.48205 12.3799 3.95068 12.8486L9.95068 18.8486C10.4193 19.3172 11.1791 19.3172 11.6477 18.8486Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8477 18.8486C19.3164 18.3799 19.3164 17.6202 18.8477 17.1515L13.6963 12L18.8477 6.84858C19.3164 6.37995 19.3164 5.62015 18.8477 5.15152C18.3791 4.68289 17.6193 4.68289 17.1507 5.15152L11.1507 11.1515C10.6821 11.6202 10.6821 12.3799 11.1507 12.8486L17.1507 18.8486C17.6193 19.3172 18.3791 19.3172 18.8477 18.8486Z"
        fill={color}
      />
    </svg>
  );
};
